import AQDataGrid from '../../AQDataGrid';
import JobCountsBar from '../JobRunCountBar';

const SyncObjectsTable = ({ stats = [] }: { stats: any }) => {
  const groupedObjects = stats.reduce((acc: any, obj: any) => {
    const key = obj.relative_path?.split('/')?.pop() || obj.relative_path;
    if (!acc[key]) {
      acc[key] = obj;
    }
    const objWithStatusCount = {
      id: obj.relative_path,
      job_type: obj.job_type,
      relative_path: obj.relative_path,
      stats: {
        ...acc[key]?.stats,
        [obj.status]: obj.record_count,
      },
      // TODO: should this be a sum of all the status record counts?
      total_records: obj.record_count + (acc[key]?.total_records || 0),
    };

    acc[key] = objWithStatusCount;

    return acc;
  }, {});

  // Sort grouped objects alphabetically by filename
  const sortedGroupedObjects = Object.values(groupedObjects).sort(
    (a: any, b: any) => {
      const filenameA = a.relative_path.split('/').pop() || '';
      const filenameB = b.relative_path.split('/').pop() || '';
      return filenameA.localeCompare(filenameB);
    },
  );
  return (
    <AQDataGrid
      rows={sortedGroupedObjects}
      colDefs={[
        {
          field: 'relative_path',
          headerName: 'Relative Path',
          flex: 1,
          renderCell: (params: any) => {
            return params.row.relative_path;
          },
        },
        {
          field: 'name',
          headerName: 'Object Name',
          flex: 1,
          renderCell: (params: any) => {
            return params.row.relative_path.split('/').pop();
          },
        },
        {
          field: 'total_records',
          headerName: 'Total Records',
          flex: 1,
        },
        {
          field: 'stats',
          headerName: 'Stats',
          flex: 1,
          renderCell: (params: any) => {
            return (
              <JobCountsBar
                jobCounts={params.row.stats}
                statusTextMap={{
                  success: 'Successful Jobs',
                  failed: 'Failed Jobs',
                  queued: 'Queued Jobs',
                  dequeued: 'Dequeued Jobs',
                  running: 'Running Jobs',
                  pushed: 'Pushed Jobs',
                  retry: 'Retried Jobs',
                }}
              />
            );
          },
        },
      ]}
      gridProps={{
        getRowHeight: () => 'auto',
      }}
      sx={{
        '& .MuiDataGrid-cell': {
          py: 2,
          display: 'flex',
          alignItems: 'center',
        },
      }}
    />
  );
};

export default SyncObjectsTable;
